import axios from "axios";
import settings from "../../utils/settings";

import { requestCommonFilters, requestCommonSearch } from "../common/requests";
import { setLoading } from "../tag/actions";
import { NEWS_ERROR, NEWS_GET_LIST, NEWS_GET_FILTERS } from "./constants";
import defaultErrorHandler from "../global/default-error-handler";

const url = `${settings.accountsUrl}api/admin/`;
const ENDPOINT = "news";

export const requestGetFilters = () => dispatch => {
  requestCommonFilters(ENDPOINT, url)
    .then((response) => {
      dispatch({
        type: NEWS_GET_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, NEWS_ERROR));
    });
};

export const requestGetNewsList = (page = 0, size = 20, sort = "startDate,desc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, page, size, sort, filters, url)
    .then((response) => {
      dispatch({
        type: NEWS_GET_LIST,
        payload: response
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, NEWS_ERROR));
    });
};

export const requestAddNews = (entity) => axios.post(`${url}${ENDPOINT}/add`, entity);

export const requestAddPhoto = (id, photo) => {
  const formData = new FormData();
  formData.append("image", photo, photo.filename);
  return axios.post(`${url}${ENDPOINT}/${id}/photo`, formData);
};

export const requestDeleteNewsById = (id) => axios.delete(`${url}${ENDPOINT}/news/${id}`);



// WEBPACK FOOTER //
// ./src/actions/news/requests.js